import { categoryCovers } from "@/mocks/trends";

export default function CategoryGrid() {
  return (
    <section id="category" className="w-full scroll-mt-20">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-700">
              <i className="ri-hashtag"></i> CATEGORIES
            </span>
            <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">分类专区</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">六大栏目持续滚动，追瓜不迷路</p>
          </div>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categoryCovers.map((c) => (
            <a
              key={c.key}
              href={`#${c.key}`}
              onClick={(e) => e.preventDefault()}
              className="group relative block cursor-pointer overflow-hidden rounded-2xl"
            >
              <img
                src={c.image}
                alt={`${c.name}专区封面图，${c.desc}`}
                className="h-40 w-full object-cover transition duration-500 group-hover:scale-105 md:h-44"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-4">
                <div className="flex items-center gap-2">
                  <h4 className="text-lg font-bold text-white">{c.name}</h4>
                  <span className="rounded-full bg-white/20 px-2 py-0.5 text-[10px] font-medium text-white backdrop-blur-sm">
                    {c.count} 篇
                  </span>
                </div>
                <p className="mt-1 line-clamp-1 text-xs text-white/75">{c.desc}</p>
                <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-accent-300 opacity-0 transition group-hover:opacity-100">
                  进入专区 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}